import { useState } from "react";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import "./CoinAllotHeader.css";
import CoinAllotmentOverlay from "../CoinAllotmentOverlay";

const CoinAllotHeader = ({
    search,
    setSearch,
    columnSearch,
    setColumnSearch,
    onRefresh,
    totals,
}) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [transstartDate, setTransStartDate] = useState(null);
    const [transendDate, setTransEndDate] = useState(null);
    const [lastUpdatedStartDate, setlastUpdatedStartDate] = useState(null);
    const [lastUpdatedEndDate, setlastUpdatedEndDate] = useState(null);

    const handleRefresh = () => {
        setSearch("");
        setTransStartDate(null);
        setTransEndDate(null);
        setlastUpdatedStartDate(null);
        setlastUpdatedEndDate(null);
        setColumnSearch({
            status: "active",
            transactionNo: "",
            datetime: "",
            customer: "",
            coins: "",
            transactionremarks: "",
            user: "",
            mobile: "",
            type: "",
        });
        if (onRefresh) {
            onRefresh();
        }
    };

    const handleCloseOverlay = () => {
        setShowOverlay(false);
    };

    const handleSave = () => {
        if (onRefresh) onRefresh();
        setShowOverlay(false);
    };

    return (
        <div className="coinallot-list-header">
            <div className="coinallot-list-header-left">
                <div className="coinallot-list-header-search">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSearch(value); 
                            // setColumnSearch({
                            //     ...columnSearch,
                            //     mobile: value, 
                            // });
                        }}
                    />


                </div>
                <select
                    value={columnSearch.type}
                    onChange={(e) =>
                        setColumnSearch({ ...columnSearch, type: e.target.value })
                    }
                    className="coinallot-filter-dropdown"
                >
                    <option value="">All</option>
                    <option value="Allot">Allot</option>
                    <option value="Deduct">Deduct</option>
                </select>

                {/* Start Date Picker */}
                <div className="coinallot-list-date-wrapper">
                    <DatePicker
                        selected={transstartDate}
                        onChange={(date) => {
                            setTransStartDate(date);
                            setColumnSearch({
                                ...columnSearch,
                                transstartDate: date,
                            });
                        }}
                        placeholderText="Trans Start Date"
                        dateFormat="dd-MM-yyyy"
                        className="coinallot-list-date-picker"
                        popperPlacement="bottom-start"
                        showPopperArrow={false}
                        portalId="root"
                    />
                    <FaCalendarAlt className="coinallot-list-calendar-icon" />
                </div>

                {/* End Date Picker */}
                <div className="coinallot-list-date-wrapper">
                    <DatePicker
                        selected={transendDate}
                        onChange={(date) => {
                            setTransEndDate(date);
                            setColumnSearch({ ...columnSearch, transendDate: date });
                        }}
                        placeholderText="Trans End Date"
                        dateFormat="dd-MM-yyyy"
                        className="coinallot-list-date-picker"
                        popperPlacement="bottom-start"
                        showPopperArrow={false}
                        portalId="root"
                    />
                    <FaCalendarAlt className="coinallot-list-calendar-icon" />
                </div>
                  <div className="coinallot-list-date-wrapper">
                    <DatePicker
                        selected={lastUpdatedStartDate}
                        onChange={(date) => {
                            setlastUpdatedStartDate(date);
                            setColumnSearch({
                                ...columnSearch,
                                lastUpdatedStartDate: date,
                            });
                        }}
                        placeholderText="Last update Start"
                        dateFormat="dd-MM-yyyy"
                        className="coinallot-list-date-picker"
                        popperPlacement="bottom-start"
                        showPopperArrow={false}
                        portalId="root"
                    />
                    <FaCalendarAlt className="coinallot-list-calendar-icon" />
                </div>

                {/* End Date Picker */}
                <div className="coinallot-list-date-wrapper">
                    <DatePicker
                        selected={lastUpdatedEndDate}
                        onChange={(date) => {
                            setlastUpdatedEndDate(date);
                            setColumnSearch({ ...columnSearch, lastUpdatedEndDate: date });
                        }}
                        placeholderText="Last update End"
                        dateFormat="dd-MM-yyyy"
                        className="coinallot-list-date-picker"
                        popperPlacement="bottom-start"
                        showPopperArrow={false}
                        portalId="root"
                    />
                    <FaCalendarAlt className="coinallot-list-calendar-icon" />
                </div>
            </div>

            {/* Total Coins Display */}
            <div className="coinallot-total-box">
                <div>
                    <strong>Total Coins: <span
                        className={
                            totals?.net >= 0
                                ? "coinallot-total-green"
                                : "coinallot-total-red"
                        }
                    >
                        {totals?.net >= 0 ? `+${totals.net}` : totals.net}
                    </span></strong>
                    
                </div>
            </div>

            {/* Refresh and Add Buttons */}
            <div className="coinallot-list-header-right">
                <span
                    className="coinallot-refresh-icon"
                    title="Refresh"
                    onClick={handleRefresh}
                >
                    ⟳
                </span>
                <span
                    className="coinallot-add-plus"
                    onClick={() => setShowOverlay(true)}
                >
                    +
                </span>
            </div>

            {/* Overlay */}
            {showOverlay && (
                <CoinAllotmentOverlay
                    onClose={handleCloseOverlay}
                    onSave={handleSave}
                />
            )}
        </div>
    );
};

export default CoinAllotHeader;
